import { get as lodashGet } from 'lodash';

/*
 * @param {Object} savedDesign
 * @param {string} savedDesign.geometrySrc
 * @param {string} savedDesign.metadataSrc
 * @return {boolean}
 */
const isValidSavedDesign = (savedDesign) => {
  const geometrySrc = lodashGet(savedDesign, 'geometrySrc');
  const metadataSrc = lodashGet(savedDesign, 'metadataSrc');
  if (!geometrySrc || typeof geometrySrc !== 'string') return false;
  if (!metadataSrc || typeof metadataSrc !== 'string') return false;
  return true;
};

export default {
  isValidSavedDesign,
};
